import React from "react";
import { formatCurrency } from "app/lib/utils/currency";
import { Metric } from "app/lib/data/models/Metrics";
import { orZero } from "app/lib/utils/NumUtils";
import { formatMer } from "../../utils/utils";

const MerGraphDetails = ({ activeTab, activeState, selectedMetric, ...props }) => {

    return activeState ? (
        <div className="details">

            {selectedMetric === 'mer' || selectedMetric === 'roas' ? (
                <>
                    <div className="detail green">
                        <div className="inner">
                            <div className="label">MER</div>
                            <h3 className="value">{ formatMer(orZero(selectedMetric == 'mer' ? activeState.data?.metrics?.mer : activeState.data?.metrics?.roas)) }</h3>
                        </div>
                    </div>
                </>

            ) : selectedMetric === 'breakdown' ? (
                <>
                    <div className="detail green">
                        <div className="inner">
                            <div className="label">Revenue</div>
                            <h3 className="value">{ formatCurrency(orZero(activeState.data?.metrics?.revenue)) }</h3>
                        </div>
                    </div>

                    <div className="detail pink">
                        <div className="inner">
                            <div className="label">AdSpend</div>
                            <h3 className="value">{ formatCurrency(orZero(activeState.data?.metrics?.adspend)) }</h3>
                        </div>
                    </div>
                </>

            ) : (

                activeState.merPrediction && (
                    <>
                        <div className="detail green">
                            <div className="inner">
                                <div className="label">MER</div>
                                <h3 className="value">{ formatMer(orZero(activeState.data?.metrics?.mer)) }</h3>
                            </div>
                        </div>

                        <div className="detail gray">
                            <div className="inner">
                                <div className="label">{
                                    activeTab === 'last7days' && 'Next 7 Days' ||
                                    activeTab === 'last30days' && 'Next 30 Days'
                                }</div>
                                <h3 className="value">{ formatMer(orZero(activeState.data?.metrics?.merPredictionAvg)) }</h3>
                            </div>
                        </div>
                    </>
                )

            )}
        </div>
    ) : <></>

}

export default MerGraphDetails;